module.exports = __webpack_public_path__ + "img/builder-17.e54d52a9.webp";